import { render } from "./section-five.vue?vue&type=template&id=f6c5da0a&scoped=true"
const script = {}

import "./section-five.vue?vue&type=style&index=0&id=f6c5da0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c5da0a"]])

export default __exports__